import styled from 'styled-components';

export const DrawerOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  justify-content: flex-end;
`;

export const DrawerContainer = styled.div`
  background: white;
  width: 1000px;
  height: 100%;
  box-shadow: -2px 0 10px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const DrawerHeader = styled.div`
  margin: 20px 30px;
  padding-bottom: 20px;
  border-bottom: 1px solid #dddddd;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 30px;
`;

export const DrawerHeaderRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const DrawerTitle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
`;

export const DateTitle = styled.h2`
  font-size: 18px;
  font-weight: 500;
  color: #212121;
  margin: 0;
`;

export const DeliveryCount = styled.span`
  font-size: 14px;
  color: #9b9b9b;
`;

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: -8px;
  color: #212121;
  transition: background-color 0.2s;

  &:hover {
    background-color: #f8f9fa;
  }

  svg {
    width: 25px;
    height: 25px;
  }
`;

export const DrawerContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 0;
`;

export const DeliveryTable = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const TableRow = styled.div`
  display: grid;
  grid-template-columns: 0.8fr 1.4fr 0.8fr 2fr;
  gap: 12px;
  padding: 12px 30px;
  border-bottom: 1px solid #f6f7f8;
  align-items: center;
  min-height: 50px;

  &:last-child {
    border-bottom: none;
  }
`;

export const TableCell = styled.div`
  color: #212121;
  font-size: 14px;
  line-height: 1.4;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const TableCellSubject = styled.div`
  color: #212121;
  font-size: 14px;
  line-height: 1.4;
  overflow-wrap: break-word;
`;

export const ExportButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  background: white;
  border: 1px solid #ced4da;
  border-radius: 13px;
  padding: 8px 16px;
  font-size: 16px;
  color: #212121;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: #f8f9fa;
    border-color: #007bff;
    color: #007bff;
  }

  &:active {
    transform: translateY(1px);
  }

  svg {
    width: 18px;
    height: 18px;
  }
`;

export const EmptyStateContainer = styled.div`
  text-align: center;
  padding: 40px;
  color: #666;
`;
